export default "__VITE_ASSET__29b73c5c__"